import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";

const STATUSES = ["pending", "contacted", "confirmed", "engraving", "delivered", "declined"];

export default function AdminLegacy() {
  const [reqs, setReqs] = useState([]);

  const load = () => api.get("/legacy/requests").then((r) => setReqs(r.data || []));
  useEffect(() => { load(); }, []);

  const update = async (id, status) => {
    try {
      await api.put(`/legacy/requests/${id}`, { status });
      toast.success("Updated");
      load();
    } catch { toast.error("Failed"); }
  };

  return (
    <div className="p-8 md:p-12" data-testid="admin-legacy">
      <header className="mb-8">
        <p className="text-[11px] tracking-luxury uppercase text-poche-gold">Atelier · Limited Edition</p>
        <h1 className="font-serif text-5xl mt-2">Legacy Requests</h1>
      </header>
      <div className="grid gap-4">
        {reqs.map((r) => (
          <div key={r.request_id} className="bg-poche-ink border border-poche-gold/20 p-6 grid grid-cols-1 md:grid-cols-12 gap-4" data-testid={`legacy-req-${r.request_id}`}>
            <div className="md:col-span-3">
              <div className="text-[10px] tracking-luxury uppercase text-poche-gold">#{r.request_id.slice(-6).toUpperCase()}</div>
              <div className="font-serif text-xl mt-1">{r.name}</div>
              <div className="text-xs text-white/55 mt-1">{r.country}</div>
            </div>
            <div className="md:col-span-3 text-sm">
              <div className="text-white/65">{r.email}</div>
              <div className="text-white/65">{r.phone}</div>
            </div>
            <div className="md:col-span-3 text-sm">
              <div className="text-[10px] tracking-luxury uppercase text-white/45">Engraving</div>
              <div className="font-serif text-lg text-poche-gold">{r.engraving}</div>
              {r.notes && <div className="text-xs text-white/55 mt-1">Notes: {r.notes}</div>}
            </div>
            <div className="md:col-span-3 flex flex-col gap-2">
              <span className="text-[10px] tracking-luxury uppercase border border-poche-gold/40 text-poche-gold px-2 py-1 self-start">{r.status}</span>
              <select
                data-testid={`legacy-status-${r.request_id}`}
                value={r.status}
                onChange={(e) => update(r.request_id, e.target.value)}
                className="bg-transparent border border-white/15 text-[10px] tracking-luxury uppercase px-2 py-1.5 focus:border-poche-gold focus:outline-none"
              >
                {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
          </div>
        ))}
        {reqs.length === 0 && <div className="text-center text-white/45 py-16 text-sm">No legacy requests yet.</div>}
      </div>
    </div>
  );
}
